import { KdsModal, KdsText, VStack } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "@/hooks";
import { type ModalCancelBriefProps } from "./ModalCancelBrief.types";

export const ModalCancelBrief = ({
  isOpen,
  onOpenChange,
  onConfirmExit,
  onReset,
}: ModalCancelBriefProps) => {
  const { t } = useTranslate();
  const navigate = useNavigate();
  const location = useLocation();
  const toaster = useToasts();

  const isPending = false;
  const fromPage = location.state?.from;

  const handleSubmit = async () => {
    toaster.add({
      title: t("openBrief.modalCancelBrief.toastSuccess"),
      state: "success",
    });

    if (onReset) {
      onReset();
    }

    // Timeout to avoid race condition with the reset of the AI chat
    setTimeout(() => {
      if (onConfirmExit) {
        onConfirmExit();
      } else {
        void navigate(fromPage || "/open-brief", { replace: true });
      }
    }, 0);
  };

  return (
    <KdsModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="sm"
      dialogProps={{
        dialogHeaderProps: {
          title: t("openBrief.modalCancelBrief.title"),
        },
        content: (
          <VStack gap="sp-md">
            <KdsText size="title-md">
              {t("openBrief.modalCancelBrief.description1")}
            </KdsText>

            <KdsText>{t("openBrief.modalCancelBrief.description2")}</KdsText>
          </VStack>
        ),
        dialogFooterProps: {
          buttonProps: [
            {
              children: t("buttons.confirmExit"),
              variant: "outlined",
              color: "error",
              isLoading: isPending,
              disabled: isPending,
              onPress: handleSubmit,
            },
            {
              disabled: isPending,
              isLoading: isPending,
              children: t("buttons.stayOnPage"),
              onPress: onOpenChange,
            },
          ],
        },
      }}
    />
  );
};
